import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Settings from "./components/Settings";
import Calucator from "./pages/Calucator";
import MainPage from "./pages/MainPage";


function App() {
  return (
    <div className="main">
      <Settings />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/calucator" element={<Calucator/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
